import React from 'react';
import { ROUTES } from '../../../global/constants';
import { NavLink } from 'react-router-dom';
import { LoggedInMenu } from '../../../ui/components';
import { logout } from '../../../auth/actions';
import { useSelector } from 'react-redux';
import { getUsername } from '../../../auth/selectors';
import { WrappedMessage } from '../../../utils';
import messages from '../../displayMessages';

const Navbar: React.FC = () => {

    const loggedInUsername = useSelector(getUsername);

    return (
        <nav className='navbar-career'>
            <div className='navbar-content'>
                <NavLink to={ROUTES.CareerExplorer.HOME}>
                    <div className='navbar__icon'>
                        <img
                            alt='CareerXplorer'
                            title='CareerXplorer'
                            src='/assets/images/career-explorer/career-xplorer-logo.svg'
                        />
                    </div>
                </NavLink>
                {loggedInUsername &&
                  <div className='menu-items'>
                    <NavLink to={ROUTES.CareerExplorer.SAVED_CAREERS} className='menu-option'>
                      <WrappedMessage message={messages.myCareerNavOption} />
                    </NavLink>
                    <LoggedInMenu
                      className='hide-mobile'
                      onLogOut={logout}
                      username={loggedInUsername}
                    />
                  </div>
                }
            </div>
        </nav>
    );
};

export default Navbar;
